import { create } from "zustand";
import type { AuthSession } from "../types/auth.types.ts";

interface AuthState {
  session: AuthSession | null;
  setSession: (session: AuthSession) => void;
  signOut: () => void;
  bootstrap: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  setSession: (session) => {
    localStorage.setItem("issp.session", JSON.stringify(session));
    set({ session });
  },
  signOut: () => {
    localStorage.removeItem("issp.session");
    set({ session: null });
  },
  bootstrap: () => {
    const stored = localStorage.getItem("issp.session");
    if (stored) {
      try {
        const parsed = JSON.parse(stored) as AuthSession;
        set({ session: parsed });
      } catch {
        localStorage.removeItem("issp.session");
      }
    }
  }
}));
